import { connect } from 'react-redux'
import Event from './Event.jsx'
import {
    getCollaborativeIndexationCreationFields,
    getDefaultEventPlace,
} from 'redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from 'redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value))
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    hasDefaultEventPlace: getDefaultEventPlace(state) !== null,
})

export const EventContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Event)
